import { InputSearch } from '@cobliteam/ui/form';
import { cn } from '@cobliteam/ui/utils';
import { ErrorBoundary } from 'react-error-boundary';
import GlobalSearchContent from './containers/GlobalSearchContent';
import useFetchData from './hooks/useFetchData';
import { GlobalSearchProvider } from './provider/GlobalSearchProvider';
import { ProviderPersistQueryClient } from './provider/PersisterProvider';

const INPUT_SEARCH_CLASS = 'w-[300px]';

const GlobalSearchTrigger = () => {
  const { isLoading, fuse, data, isRefetching, handleUpdateData } = useFetchData();
  if (isLoading || !fuse || !data) return <InputSearch onChange={() => ''} size='sm' className={INPUT_SEARCH_CLASS} placeholder='Carregando dados da frota...' disabled />;
  return (
    <GlobalSearchProvider fuse={fuse} data={data}>
      <GlobalSearchContent handleUpdateData={handleUpdateData} isRefetching={isRefetching} />
    </GlobalSearchProvider>
  );
};

const GlobalSearch = () => {
  return (
    <ErrorBoundary
      FallbackComponent={() => (
        <InputSearch
          onChange={() => ''}
          size='sm'
          className={cn(INPUT_SEARCH_CLASS, '!border-warning-6 !bg-warning-2')}
          placeholder='Erro ao carregar a busca global...'
          disabled
        />
      )}
    >
      <ProviderPersistQueryClient>
        <GlobalSearchTrigger />
      </ProviderPersistQueryClient>
    </ErrorBoundary>
  );
};

export default GlobalSearch;
